"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuSwitchResponseDto = void 0;
const tslib_1 = require("tslib");
const swagger_v4_1 = require("@nestjs/swagger-v4");
const common_1 = require("@goparrot/common");
const class_transformer_1 = require("class-transformer");
class MenuSwitchResponseDto {
}
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ groups: [common_1.DefaultExposeGroupEnum.READ] }),
    (0, swagger_v4_1.ApiPropertyOptional)({
        type: () => String,
        isArray: true,
        description: 'List of items unique names that was updated with prefixed title',
        uniqueItems: true,
    }),
    tslib_1.__metadata("design:type", Array)
], MenuSwitchResponseDto.prototype, "prefixedItemsUniqueNames", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ groups: [common_1.DefaultExposeGroupEnum.READ] }),
    (0, swagger_v4_1.ApiPropertyOptional)({
        type: () => String,
        isArray: true,
        description: 'List of items unique names that was updated with un-prefixed title',
        uniqueItems: true,
    }),
    tslib_1.__metadata("design:type", Array)
], MenuSwitchResponseDto.prototype, "unPrefixedItemsUniqueNames", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ groups: [common_1.DefaultExposeGroupEnum.READ] }),
    (0, swagger_v4_1.ApiPropertyOptional)({ type: () => String, isArray: true, description: 'List of items unique names that was removed', uniqueItems: true }),
    tslib_1.__metadata("design:type", Array)
], MenuSwitchResponseDto.prototype, "removedItemsUniqueNames", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ groups: [common_1.DefaultExposeGroupEnum.READ] }),
    (0, swagger_v4_1.ApiPropertyOptional)({ type: () => String, isArray: true, description: 'List of items items pos guids that was updated with prefixed title' }),
    tslib_1.__metadata("design:type", Array)
], MenuSwitchResponseDto.prototype, "prefixedItemsPosGuids", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ groups: [common_1.DefaultExposeGroupEnum.READ] }),
    (0, swagger_v4_1.ApiPropertyOptional)({ type: () => String, isArray: true, description: 'List of items items pos guids that was updated with un-prefixed title' }),
    tslib_1.__metadata("design:type", Array)
], MenuSwitchResponseDto.prototype, "unPrefixedItemsPosGuids", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ groups: [common_1.DefaultExposeGroupEnum.READ] }),
    (0, swagger_v4_1.ApiPropertyOptional)({ type: () => String, isArray: true, description: 'List of items pos guids that was removed' }),
    tslib_1.__metadata("design:type", Array)
], MenuSwitchResponseDto.prototype, "removedItemsPosGuids", void 0);
exports.MenuSwitchResponseDto = MenuSwitchResponseDto;
//# sourceMappingURL=MenuSwitchResponseDto.js.map